import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMute = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12 3.75001C12 3.45315 11.8249 3.18423 11.5534 3.06413C11.2819 2.94403 10.9652 2.99537 10.7455 3.19506L5.46004 8.00001H2.75C1.7835 8.00001 1 8.78352 1 9.75001V14.25C1 15.2165 1.7835 16 2.75 16H5.46004L10.7455 20.805C10.9652 21.0047 11.2819 21.056 11.5534 20.9359C11.8249 20.8158 12 20.5469 12 20.25V3.75001ZM6.2545 9.30497L10.5 5.44543V18.5546L6.2545 14.6951C6.11645 14.5696 5.93657 14.5 5.75 14.5H2.75C2.61193 14.5 2.5 14.3881 2.5 14.25V9.75001C2.5 9.61194 2.61193 9.50001 2.75 9.50001H5.75C5.93657 9.50001 6.11645 9.43047 6.2545 9.30497Z",
		fill: "var(--colors-grey-1)"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M16.2803 8.21967C15.9874 7.92678 15.5126 7.92678 15.2197 8.21967C14.9268 8.51256 14.9268 8.98744 15.2197 9.28033L17.9393 12L15.2197 14.7197C14.9268 15.0126 14.9268 15.4874 15.2197 15.7803C15.5126 16.0732 15.9874 16.0732 16.2803 15.7803L19 13.0607L21.7197 15.7803C22.0126 16.0732 22.4874 16.0732 22.7803 15.7803C23.0732 15.4874 23.0732 15.0126 22.7803 14.7197L20.0607 12L22.7803 9.28033C23.0732 8.98744 23.0732 8.51256 22.7803 8.21967C22.4874 7.92678 22.0126 7.92678 21.7197 8.21967L19 10.9393L16.2803 8.21967Z",
		fill: "var(--colors-grey-1)"
	})]
});
export default SvgMute;
